<div class="settings-container">
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</div>
